import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  TemplateRef
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import * as _ from "underscore";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";
import { GUID } from "./../../guid";
import { MatDialog } from "@angular/material";
import { TranslationService } from "src/app/translation.service";

@Component({
  selector: "app-customviewnew",
  templateUrl: "./customviewnew.component.html",
  styleUrls: ["./customviewnew.component.scss"]
})
export class CustomViewNewComponent implements OnInit, AfterViewInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;
  isLoading = false;
  isError = false;
  errorMessage = "";
  isDataLoaded = false;
  profileId = "";
  metaobjectId = "";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  publicAccess = false;
  visibleMeChecked = false;
  visibleAllChecked = true;
  mode = "New";
  guid: GUID;
  metalayout: any;
  metaProfileLayoutId = "";
  metaLayoutGroupId = "";
  metaProfileLayoutWebId = "";

  recordTypes = [];
  queues = [];
  queueList = [];
  fields = [];
  fieldList = [];
  sortFieldList = [];
  operatorList = [];
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false }
  ];

  sortOrderList = [
    { label: "ASC", value: "asc" },
    { label: "DESC", value: "desc" }
  ];

  CategorySelect = [
    { value: "DEFAULT", label: "DEFAULT" },
    { value: "COMPACT", label: "COMPACT" },
    { value: "MOBILE", label: "MOBILE" }
  ];

  DeviceTypeSelect = [
    { value: "WEB", label: "WEB" },
    { value: "MOBILE", label: "MOBILE" }
  ];

  picklistValueList = [];

  fieldsToDo = [];
  fieldsDone = [];

  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",

    id: "",
    displayname: "",
    viewname: "",
    name: "",
    publicaccess: false,
    active: true,
    attributes: {},

    targeturl: "",
    columncount: 0,
    tabkeyorder: "L-R",
    hascustomview: false,
    clonable: false,
    editable: true,
    deletable: false,
    haskanbanview: true,
    searchtext: "",
    sortby: "createdon",
    sortorder: "desc",
    sinceversionseq: 0,
    deprecatedversionseq: 0,
    category: "",
    devicetype: ""
  });

  criteriaForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    id: "",
    filterbyowner: "My Records",
    queueid: new FormControl({ value: "", disabled: true }),
    queuename: ""
  });

  filterForm: FormGroup;
  filteritems: FormArray;
  languages: any[];
  data: any;
  dialogRef: any;
  translatedLabels: any;
  modifiedby: any;
  modifieddate: any;

  labelChanged() {
    var txtlabel = this.detailForm.controls["displayname"].value.trim();
    console.log("txtlabel", txtlabel);
    //if(this.detailForm.controls['viewname'].value.trim() == '')
    //{
    txtlabel = txtlabel.replace(/\w\S*/g, function (txt: string) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    // txtlabel = txtlabel.replace(/ /g, "_");
    // this.detailForm.controls["viewname"].setValue(txtlabel);
    //}
  }

  filterOwnerChanged(event: { target: { value: string } }, index: any) {
    console.log("event", event);
    if (event.target.value.toLowerCase() == "queue") {
      this.criteriaForm.controls["queueid"].enable();
    } else {
      this.criteriaForm.controls["queueid"].setValue("");
      this.criteriaForm.controls["queueid"].disable();
    }
  }

  fieldSelected(
    event: { id: any; fieldtype: any; options: string },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("options").setValue(event.options);
        if (c.get("fieldoperator").value == "") {
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options);
          this.picklistValueList[index] = arr;
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        c.get("fieldvalue").setValue("");
        break;
      }
      i++;
    }
  }

  queueSelected(event: { label: any }) {
    console.log("event", event);
    this.criteriaForm.controls["queuename"].setValue(event.label);
  }

  sortFieldSelected(event: { value: string; label: any }) {
    console.log("sortFieldSelected", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["sortby"].setValue(event.value);
      // this.detailForm.controls["parentobjectname"].setValue(event.label);
    } else {
      this.detailForm.controls["sortby"].setValue("");
      // this.detailForm.controls["parentobjectname"].setValue("");
    }
  }

  sortOrderSelected(event: { value: string; label: any }) {
    console.log("sortOrderSelected", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["sortorder"].setValue(event.value);
      // this.detailForm.controls["parentobjectname"].setValue(event.label);
    } else {
      this.detailForm.controls["sortorder"].setValue("");
      // this.detailForm.controls["parentobjectname"].setValue("");
    }
  }

  addFilter(index: any) {
    if (this.filteritems != null && this.filteritems.length < 10) {
      this.addFilterItem("", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }

  createItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    vl: any,
    flogic: string
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      fieldoperator: opr,
      fieldvalue: vl,
      filterlogic: flogic
    });
  }

  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    vl: string,
    flogic = "AND"
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createItem(id, name, ftype, opt, opr, vl, flogic)
    );
    this.picklistValueList.push([]);
  }

  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }
  loadDefaultDoneList() {
    var defaultFieldNames = [];
    var defaultListviewFieldsJSONArray = {};
    defaultListviewFieldsJSONArray = this.appConfig.defaultListviewFields;
    if (defaultListviewFieldsJSONArray.hasOwnProperty(this.metaobjectName)) {
      defaultFieldNames = defaultListviewFieldsJSONArray[this.metaobjectName];
    } else if (defaultListviewFieldsJSONArray.hasOwnProperty("anyothers")) {
      defaultFieldNames = defaultListviewFieldsJSONArray["anyothers"];
    }

    //console.log("defaulfieldnames", defaultFieldNames);

    for (let i = 0; i < this.fields.length; i++) {
      var field = this.fields[i];

      //skip id type fields if there
      if (field.fieldtype.toLowerCase() == "id") continue;

      //skip fields with visibility false
      if (field.visible == false) continue;

      //skip fields deleted, ownertype etc.,
      if (
        field.fieldname.toLowerCase() == "deleted" ||
        field.fieldname.toLowerCase() == "ownertype" ||
        field.fieldname.toLowerCase() == "migrated" ||
        field.fieldname.toLowerCase() == "organizationid" ||
        field.fieldname.toLowerCase() == "search" ||
        field.fieldname.toLowerCase() == "date_range"
      )
        continue;

      //skip converted field if object is lead
      if (
        this.metaobjectName.toLowerCase().trim() == "lead" &&
        field.fieldname.toLowerCase() == "converted"
      )
        continue;

      var orgFieldName = field.fieldname;
      var bExistsInDefault = false;

      for (let j = 0; j < defaultFieldNames.length; j++) {
        var doneDefaultFieldName = defaultFieldNames[j];
        //console.log("doneFieldName", doneDefaultFieldName);
        if (orgFieldName.toLowerCase() == doneDefaultFieldName.toLowerCase()) {
          bExistsInDefault = true;
          this.fieldsDone.push(field);
          break;
        }
      }

      if (!bExistsInDefault) {
        this.fieldsToDo.push(field);
      }

      //finally sort the done list as given in the default field name
      var sorted = _.sortBy(
        this.fieldsDone,
        function (obj: { fieldname: any }) {
          return _.indexOf(defaultFieldNames, obj.fieldname);
        }
      );
      //console.log("sorted", sorted);
      this.fieldsDone = sorted;
    }

    //console.log("fieldstodo", this.fieldsToDo);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      //console.log("event.previousContainer", event.previousContainer.id);
      //console.log("event.container", event.container.id);
      //console.log("event.previousIndex", event.previousIndex);

      //prevent dragging the name field
      // var fld = event.previousContainer.data[event.previousIndex];
      // if (fld["fieldname"] == "name") return;

      //var fld = JSON.parse(event.previousContainer.data[event.previousIndex]);
      //console.log(fld.fieldname);
      //if(event.previousContainer.data[event.previousIndex].fieldname.)
      /*if(event.previousContainer.id = 'cdk-drop-list-1') //DoneList
      {
        if(this.fieldsDone.length == 1){
          this.showWarning("Selected fields cannot be empty");
          return;           
        }
      }*/

      if (this.fieldsDone.length < 21) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService,
    public dialog: MatDialog,
    private translationService: TranslationService
  ) {}
  translateForm: FormGroup;

  ngAfterViewInit() {
    //    console.log(document.getElementById("visibleme").getAttribute("checked"));
    //  console.log(document.getElementById("visibleall").getAttribute("checked"));
  }
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      if (this.mode.toLocaleLowerCase().trim() == "edit") {
        this.metalayoutId = this.route.snapshot.params.id;
        this.metalayoutName = this.route.snapshot.params.metalayoutname;
        this.displayName = this.route.snapshot.params.displayname;
      }
      this.profileId = this.route.snapshot.params.profileid;
      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.publicaccess == "true";
      this.publicAccess = boolValue;
    });
    console.log("response00000 metalayoutName", this.displayName);

    this.filterForm = this.fb.group({
      metaobjectid: "",
      metaobjectname: "",
      filteritems: this.fb.array([]),
      filterlogic: ""
    });

    //create operator type picklist from operatortypes
    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel
      });
    }

    this.guid = new GUID();

    console.log("mode", this.mode);

    //Check if the profile has customview related permissions
    if (this.mode.toLocaleLowerCase().trim() == "new") {
      this.checkCustomViewCreatePermission().then((res) => {
        console.log("response00000", res);

        if (!this.isError) {
          //load queues
          this.getQueuesForSelection().then((res) => {
            console.log("queueList", this.queueList);
          }); //getQueuesForSelection()

          //load recordtypes
          this.getRecordTypes().then((res) => {
            console.log("recordtypes", this.recordTypes);
          }); //getRecordTypes()

          //load fields
          this.getMetaFieldsForSelection().then((res) => {
            console.log("response1111", res);

            //load default done list first
            this.loadDefaultDoneList();

            this.addFilterItem("", "", "", [], "", "");
            this.addFilterItem("", "", "", [], "", "");
            this.addFilterItem("", "", "", [], "", "");

            this.isDataLoaded = true;
          }); //getMetaFieldsForSelection()
        }
      });
    } else {
      this.checkCustomViewEditPermission().then((res) => {
        console.log("response22222", res);
        if (!this.isError) {
          //load queues
          this.getQueuesForSelection().then((res) => {
            console.log("queueList", this.queueList);
          }); //getQueuesForSelection()

          //load recordtypes
          this.getRecordTypes().then((res) => {
            console.log("recordtypes", this.recordTypes);
          }); //getRecordTypes()

          this.getMetaFieldsForSelection().then((res) => {
            console.log("response1111", res);

            // load metalayout details
            this.getMetaLayoutByName().then((res) => {
              console.log("this.metalayout", this.metalayout);
              // console.log("this.res", res);

              //assign metalayout detail data
              this.assignMetalayoutData();

              if (this.filteritems == null) {
                this.addFilterItem("", "", "", "", "", "");
                this.addFilterItem("", "", "", "", "", "");
                this.addFilterItem("", "", "", "", "", "");
              } else if (this.filteritems.length == 1) {
                this.addFilterItem("", "", "", "", "", "");
                this.addFilterItem("", "", "", "", "", "");
              } else if (this.filteritems.length == 2) {
                this.addFilterItem("", "", "", "", "", "");
              }

              this.isDataLoaded = true;
            }); //getMetaLayoutByName()
          });
        }
      });
    }

    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: ""
    });
    // Initialize with one language by default
    this.addLang();
    this.getLanguage();
    this.getTranslationLabelById();
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language
              });
            }
            this.languages = objArr;

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }
  // languages: string[] = ["English", "es", "French", "German"];
  // selectedLanguage: string = "es";
  translatedText: string = "";

  // translateForm = new FormGroup({
  //   translate: new FormArray([
  //     new FormGroup({
  //       selectedLanguage: new FormControl(""),
  //       translatedText: new FormControl(""),
  //       // number: new FormControl(''),
  //       // email: new FormControl('')
  //     }),
  //   ]),

  // });

  translatingDialog(labelname: any): void {
    console.log("labelname", labelname);

    if (!labelname) {
      return;
    }

    this.translateForm.patchValue({ label: labelname });
    this.data = {
      labelname: labelname
    };

    this.dialogRef = this.dialog.open(this.translateDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translate.push(translateGroup);
  }

  // translator() {
  //   const selectedLanguage =
  //     this.translateForm.value.translate[0].selectedLanguage;
  //   const labelname = this.data.labelname;
  //   console.log(selectedLanguage);
  //   console.log(this.translateForm.value.translate);
  //   this.translationService
  //     .translate(labelname, selectedLanguage)
  //     .subscribe((response: any) => {
  //       this.translatedText = response.data.translations[0].translatedText;
  //     });
  // }
  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    this.dialogRef.close();
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  close() {
    this.dialogRef.close();
  }

  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metalayoutlabeltranslation: {
          metalayoutid: this.metalayoutId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getLayoutTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // Loop through the response and add translation fields
          if (res.data.metalayouttranslation) {
            this.translate.clear();
            res.data.metalayouttranslation.metalayoutlabeltranslation.forEach(
              (translation) => {
                const translateGroup = this.fb.group({
                  languageCode: [translation.languagecode, Validators.required],
                  translatedName: [
                    translation.translatedlabel,
                    Validators.required
                  ]
                });
                this.translate.push(translateGroup);
                console.log(this.translate);
              }
            );
            // After populating translateForm, update translatedLabels
            this.translatedLabels =
              res.data.metalayouttranslation.metalayoutlabeltranslation.map(
                (translation) => ({
                  languageCode: translation.languagecode,
                  translatedName: translation.translatedlabel
                })
              );
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  checkCustomViewCreatePermission() {
    return new Promise((resolve, reject) => {
      console.log("checkCustomViewCreatePermission");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          permissions: {
            profileid: this.profileId
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.checkCustomViewCreatePermission(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            if (res.data.haspermission == false) {
              this.errorMessage =
                "Permission denied. You don't have sufficient permission to perform the current action";
              this.isError = true;
            }
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No Permission!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  checkCustomViewEditPermission() {
    return new Promise((resolve, reject) => {
      console.log("checkCustomViewEditPermission");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          permissions: {
            profileid: this.profileId,
            publicaccess: this.publicAccess
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.checkCustomViewEditPermission(postOption).subscribe(
        (res) => {
          console.log("checkCustomViewEditPermission");

          console.log(res);
          if (res !== null && res.success == 1) {
            if (res.data.haspermission == false) {
              this.errorMessage =
                "Permission denied. You don't have sufficient permission to perform the current action";
              this.isError = true;
            }
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No permission");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetaLayoutByName() {
    return new Promise((resolve, reject) => {
      console.log("getMetaLayoutByName");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metalayout: {
            name: this.metalayoutName,
            id: this.metalayoutId
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetalayoutByName(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metalayout = res.data.metalayout;
            this.modifiedby = this.metalayout.modifiedby;
            this.modifieddate = this.metalayout.modifieddate;
            this.isLoading = false;

            console.log("metalayout!!!!", this.metalayout);
            resolve(null);
          } else {
            console.log("No metalayout data");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //add default --None-- into field list
            this.fieldList.push({
              value: "--None--",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: ""
            });

            this.sortFieldList.push({
              value: "--None--",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: ""
            });

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.fieldList.push({
                value: field.fieldname,
                label: strLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                id: field.id
              });
            }

            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];
              console.log(field.fieldtype);

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              // if (
              //   field.fieldtype.toLowerCase() !== "text" &&
              //   field.fieldtype.toLowerCase() !== "number" &&
              //   field.fieldtype.toLowerCase() !== "date" &&
              //   field.fieldtype.toLowerCase() !== "datetime"
              // )
              if (
                field.fieldtype.toLowerCase() !== "text" &&
                field.fieldtype.toLowerCase() !== "textarea" &&
                field.fieldtype.toLowerCase() !== "longtext" &&
                field.fieldtype.toLowerCase() !== "searchtext" &&
                field.fieldtype.toLowerCase() !== "email" &&
                field.fieldtype.toLowerCase() !== "phone" &&
                field.fieldtype.toLowerCase() !== "dropdown" &&
                field.fieldtype.toLowerCase() !== "picklist" &&
                field.fieldtype.toLowerCase() !== "radio" &&
                field.fieldtype.toLowerCase() !== "autonumber" &&
                field.fieldtype.toLowerCase() !== "number" &&
                field.fieldtype.toLowerCase() !== "currency" &&
                field.fieldtype.toLowerCase() !== "double" &&
                field.fieldtype.toLowerCase() !== "date" &&
                field.fieldtype.toLowerCase() !== "datetime" &&
                field.fieldtype.toLowerCase() !== "time" &&
                field.fieldtype.toLowerCase() !== "timestamp" &&
                field.fieldtype.toLowerCase() !== "daterange"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.sortFieldList.push({
                value: field.fieldname,
                label: strLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                id: field.id
              });
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getQueuesForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getQueuesForSelection");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        )
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getQueuesForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.queues = res.data.queues;

            this.queueList = [];
            //create queuelist from queues as readable form by selection control
            for (let i = 0; i < this.queues.length; i++) {
              var queue = this.queues[i];
              //convert to titecase
              var strLabel = queue.label;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.queueList.push({
                value: queue.id,
                label: strLabel
              });
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getRecordTypes() {
    return new Promise((resolve, reject) => {
      console.log("getRecordTypes");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          recordtype: {
            metaobjectid: this.metaobjectId
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getRecordTypes(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.recordTypes = res.data.recordtypes;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No RecordType data");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  assignMetalayoutData() {
    if (this.metalayout != null) {
      this.metalayoutId = this.metalayout.id;
      this.metalayoutName = this.metalayout.name;

      if (
        this.metalayout.metaprofilelayouts != null &&
        this.metalayout.metaprofilelayouts.length > 0
      ) {
        this.metaProfileLayoutId = this.metalayout.metaprofilelayouts[0].id;
        this.metaLayoutGroupId = this.metalayout.metalayoutgroups[0].id;
        this.metaProfileLayoutWebId =
          this.metalayout.metaprofilelayoutwebs[0].id;
      }

      //detailform
      this.detailForm.controls["metaobjectid"].setValue(
        this.metalayout.metaobjectid
      );
      this.detailForm.controls["metaobjectname"].setValue(
        this.metalayout.metaobjectname
      );

      this.detailForm.controls["id"].setValue(this.metalayout.id);
      this.detailForm.controls["displayname"].setValue(
        this.metalayout.displayname
      );
      this.detailForm.controls["viewname"].setValue(this.metalayout.viewname);
      this.detailForm.controls["name"].setValue(this.metalayout.name);
      this.detailForm.controls["publicaccess"].setValue(
        this.metalayout.publicaccess
      );
      if (this.metalayout.publicaccess == true) {
        this.visibleAllChecked = true;
        this.visibleMeChecked = false;
      } else {
        this.visibleMeChecked = true;
        this.visibleAllChecked = false;
      }

      this.detailForm.controls["active"].setValue(this.metalayout.active);
      this.detailForm.controls["attributes"].setValue(
        this.metalayout.attributes
      );

      this.detailForm.controls["targeturl"].setValue(this.metalayout.targeturl);
      this.detailForm.controls["columncount"].setValue(
        this.metalayout.columncount
      );
      this.detailForm.controls["tabkeyorder"].setValue(
        this.metalayout.tabkeyorder
      );
      this.detailForm.controls["hascustomview"].setValue(
        this.metalayout.hascustomview
      );
      this.detailForm.controls["clonable"].setValue(this.metalayout.clonable);
      this.detailForm.controls["editable"].setValue(this.metalayout.editable);
      this.detailForm.controls["deletable"].setValue(this.metalayout.deletable);
      this.detailForm.controls["haskanbanview"].setValue(
        this.metalayout.haskanbanview
      );
      this.detailForm.controls["searchtext"].setValue(
        this.metalayout.searchtext
      );
      this.detailForm.controls["sortby"].setValue(this.metalayout.sortby);
      // this.detailForm.controls["sortby"].setValue("name");

      this.detailForm.controls["sortorder"].setValue(this.metalayout.sortorder);
      this.detailForm.controls["sinceversionseq"].setValue(
        this.metalayout.sinceversionseq != null
          ? this.metalayout.sinceversionseq
          : 0
      );
      this.detailForm.controls["deprecatedversionseq"].setValue(
        this.metalayout.deprecatedversionseq != null
          ? this.metalayout.deprecatedversionseq
          : 0
      );
      this.detailForm.controls["category"].setValue(this.metalayout.category);
      this.detailForm.controls["devicetype"].setValue(
        this.metalayout.devicetype
      );
      console.log(this.metalayout.sortorder);

      //criteriaform
      this.criteriaForm.controls["metaobjectid"].setValue(
        this.metalayout.metaobjectid
      );
      this.criteriaForm.controls["metaobjectname"].setValue(
        this.metalayout.metaobjectname
      );
      this.criteriaForm.controls["id"].setValue(this.metalayout.id);
      this.criteriaForm.controls["filterbyowner"].setValue(
        this.metalayout.filterbyowner
      );
      this.criteriaForm.controls["queueid"].setValue(this.metalayout.queueid);
      this.criteriaForm.controls["queuename"].setValue(
        this.metalayout.queuename
      );

      if (this.metalayout.filterbyowner.toLowerCase() == "queue")
        this.criteriaForm.controls["queueid"].enable();

      if (this.metalayout.metaprofilelayoutcriterias.length > 0) {
        this.filterForm.controls["filterlogic"].setValue(
          this.metalayout.metaprofilelayoutcriterias[0].filterlogic
        );
      }

      //filterform

      var criterias = this.metalayout.metaprofilelayoutcriterias;
      var index = 0;
      for (let i = 0; i < criterias.length; i++) {
        // this.filterForm.controls["filterlogic"].setValue(
        //   criteria.filterlogic
        // );
        var criteria = criterias[i];

        console.log("fieldname", criteria.metafieldname);
        //skip id type fields if there
        if (criteria.metafieldname.toLowerCase() == "deleted") {
          console.log("deleted found.");
          continue;
        }
        //skip converted field if object is lead
        if (
          this.metaobjectName.toLowerCase().trim() == "lead" &&
          criteria.metafieldname.toLowerCase() == "converted"
        ) {
          console.log("converted found.");
          continue;
        }

        //get addnl field detail from fields
        var fldName = "";
        var fldLabel = "";
        var fldType = "";
        var fldOptions: string;

        for (let j = 0; j < this.fields.length; j++) {
          if (this.fields[j].id == criteria.metafieldid) {
            fldName = this.fields[j].fieldname;
            //convert to titecase
            fldLabel = this.fields[j].labelname;
            fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
            fldType = this.fields[j].fieldtype;

            if (this.fields[j].options != null) {
              fldOptions = this.fields[j].options;
            }
            //console.log("fldOptions", fldOptions);
            break;
          }
        }

        if (fldType == "checkbox") {
          criteria.fieldvalue = JSON.parse(criteria.fieldvalue);
        }

        //add item
        console.log("criteria.value", criteria);
        this.addFilterItem(
          criteria.metafieldid,
          fldName,
          fldType,
          fldOptions,
          criteria.fieldoperator,
          criteria.fieldvalue,
          criteria.filterlogic
        );
        if (fldOptions != null) {
          var arr = JSON.parse(fldOptions);
          this.picklistValueList[index] = arr;
        }

        index++;
      }

      //load fieldtodo and done
      var metaLayoutGroupFields = this.metalayout.metalayoutgroupfields;
      if (metaLayoutGroupFields.length > 0) {
        //collect fieldnames for sorting
        var groupFieldNames = [];
        for (let j = 0; j < metaLayoutGroupFields.length; j++) {
          groupFieldNames.push(metaLayoutGroupFields[j].fieldname);
        }

        for (let i = 0; i < this.fields.length; i++) {
          var field = this.fields[i];

          //skip id type fields if there
          if (field.fieldtype.toLowerCase() == "id") continue;

          //skip fields with visibility false
          if (field.visible == false) continue;

          //skip fields deleted, ownertype etc.,
          if (
            field.fieldname.toLowerCase() == "deleted" ||
            field.fieldname.toLowerCase() == "ownertype" ||
            field.fieldname.toLowerCase() == "migrated" ||
            field.fieldname.toLowerCase() == "organizationid" ||
            field.fieldname.toLowerCase() == "search" ||
            field.fieldname.toLowerCase() == "date_range"
          )
            continue;

          //skip converted field if object is lead
          if (
            this.metaobjectName.toLowerCase().trim() == "lead" &&
            field.fieldname.toLowerCase() == "converted"
          )
            continue;

          var orgFieldName = field.fieldname;
          var bExistsInDefault = false;

          for (let j = 0; j < metaLayoutGroupFields.length; j++) {
            //console.log("metaLayoutGroupFields[j]", metaLayoutGroupFields[j]);
            var doneFieldName = metaLayoutGroupFields[j].fieldname;
            //console.log("index j", j);
            //console.log("doneFieldName", doneFieldName);
            if (doneFieldName.toLowerCase() == "id") continue;

            if (orgFieldName.toLowerCase() == doneFieldName.toLowerCase()) {
              bExistsInDefault = true;
              this.fieldsDone.push(field);
              break;
            }
          }

          if (!bExistsInDefault) {
            this.fieldsToDo.push(field);
          }
        }

        //finally sort the done list as given in the default field name
        var sorted = _.sortBy(
          this.fieldsDone,
          function (obj: { fieldname: any }) {
            return _.indexOf(groupFieldNames, obj.fieldname);
          }
        );
        //console.log("sorted", sorted);
        this.fieldsDone = sorted;
      }
    }
  }

  getDefaultCriteria() {
    var arrDefaultCriteria = [];

    //default criteria deleted equals false
    var fieldsFilter = this.fields.filter(function (field) {
      // return (
      //   field.fieldname.toLowerCase().trim() == "deleted" ||
      //   (field.metaobjectname.toLowerCase().trim() == "lead" &&
      //     field.fieldname.toLowerCase().trim() == "converted")
      // );
    });

    console.log("fieldsFilter***deleted", fieldsFilter);

    for (let fld of fieldsFilter) {
      var metaProfileLayoutCriteria = {
        id: this.guid.getGUID("metaprofilelayoutcriteria"),
        metaobjectid: this.metaobjectId,
        metalayoutid: this.metalayoutId,
        metafieldid: fld.id,
        fieldname: fld.fieldname,
        fieldtype: fld.fieldtype,
        operator: "equals",
        value: false,
        // filterlogic: "AND",
        filterlogic: this.filterForm.controls["filterlogic"].value
      };

      arrDefaultCriteria.push(metaProfileLayoutCriteria);
    }

    return arrDefaultCriteria;
  }

  createMetaProfileLayoutCriteria() {
    //get criteria details and assign it to postoption
    //get formarray details
    var arrMetaProfileLayoutCriteria = this.getDefaultCriteria();

    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;

      var operator = c.get("fieldoperator").value;
      if (operator.toLowerCase().trim() == "--none--") operator = "";

      var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      if (value == "--none--") value = "";

      if (fieldId != "" && operator != "") {
        var metaProfileLayoutCriteria = {
          id: this.guid.getGUID("metaprofilelayoutcriteria"),
          metaobjectid: this.metaobjectId,
          metalayoutid: this.metalayoutId,
          metafieldid: fieldId,
          fieldname: fieldName,
          fieldtype: fieldType,
          operator: operator,
          value: value,
          // filterlogic: c.get("filterlogic").value,
          filterlogic: this.filterForm.controls["filterlogic"].value
        };

        console.log(metaProfileLayoutCriteria);
        //push it to array
        arrMetaProfileLayoutCriteria.push(metaProfileLayoutCriteria);
      }
    }

    return arrMetaProfileLayoutCriteria;
  }

  createMetaLayoutGroup(metaLayoutGroupId: any, viewName: any) {
    var metaLayoutGroup = {
      id: metaLayoutGroupId,
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      name: viewName,
      showondetailpage: true,
      showoneditpage: true,
      active: true
    };
    return metaLayoutGroup;
  }

  createMetaLayoutGroupField(metaLayoutGroupId: string, groupSequence: number) {
    //get metagroupfield details and assign it to postoption
    //Id field has to be included in all customview by default so adding id field from the original field list
    var arrDefaultField = [];
    for (let i = 0; i < this.fields.length; i++) {
      var field = this.fields[i];
      //console.log("field.fieldname", field.fieldname);
      if (field.fieldname.toLowerCase() == "id") {
        arrDefaultField.push(field);
        break;
      }
    }

    //include ownerid, ownertype fields if ownername is selected in done list
    var fieldsExistsFilter = this.fieldsDone.filter(function (field) {
      return field.fieldname.toLowerCase().trim() == "ownername";
    });

    console.log("fieldsExistsFilter", fieldsExistsFilter);

    if (fieldsExistsFilter.length > 0) {
      //add ownerid, ownertype from original fields collection
      var fieldsFilter = this.fields.filter(function (field) {
        return field.fieldname.toLowerCase().trim() == "ownerid";
      });

      console.log("fieldsFilter1", fieldsFilter);
      if (fieldsFilter.length > 0) {
        arrDefaultField.push(fieldsFilter[0]);
      }

      fieldsFilter = this.fields.filter(function (field) {
        return field.fieldname.toLowerCase().trim() == "ownertype";
      });
      console.log("fieldsFilter2", fieldsFilter);
      if (fieldsFilter.length > 0) {
        arrDefaultField.push(fieldsFilter[0]);
      }
    }

    //merge or concat array
    var arrFieldsDone = arrDefaultField.concat(this.fieldsDone);
    console.log("arrFieldsDone", arrFieldsDone);

    var arrMetaGroupField = [];
    for (let j = 0; j < arrFieldsDone.length; j++) {
      var field = arrFieldsDone[j];

      var required = false;
      if (field.fieldname.toLowerCase() == "id") required = true;

      var fieldSequence = groupSequence * 1000 + (j + 1); //index j

      var metaGroupField = {
        id: this.guid.getGUID("metalayoutgroupfield"),
        metaobjectid: this.metaobjectId,
        embeddedobject: false,
        parentobjectid: "",
        metalayoutid: this.metalayoutId,
        metagroupid: metaLayoutGroupId,
        metafieldid: field.id,
        fieldname: field.fieldname,
        fieldtype: field.fieldtype,
        labelname: field.labelname,
        fieldattributes: field.attributes,
        supportingobjectid: "",
        supportingfield: false,
        standard: field.standard,
        fieldsequence: fieldSequence,
        defaultvalue: field.defaultvalue,
        required: required,
        primary: field.primaryfield,
        visible: field.visible,
        readonly: true,
        derivedfield: false,
        active: true,
        groupfieldattributes: {},
        createddate: field.createddate
      };

      var hasRecordType = this.recordTypes.length > 0 ? true : false;

      var metaGroupFieldAttributes = {};
      if (field.fieldtype.toLowerCase() == "id") {
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: "",
          linkfield: "",
          hidden: true,
          linkrelativeurl: "",
          islink: false
        };
      } else if (field.fieldname.toLowerCase() == "name") {
        //var linkrelativeurl = 'web/v1/' + this.metaobjectName + '/leadview';
        var linkrelativeurl = "web/v1/lead/leadview";
        metaGroupFieldAttributes = {
          recordtypeexist: "" + hasRecordType,
          object: this.metaobjectName,
          linkfield: "id",
          hidden: false,
          linkrelativeurl: linkrelativeurl,
          islink: true
        };
      } else {
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: "",
          linkfield: "",
          hidden: false,
          linkrelativeurl: "",
          islink: false
        };
      }

      metaGroupField.groupfieldattributes = metaGroupFieldAttributes;

      arrMetaGroupField.push(metaGroupField);
    }

    return arrMetaGroupField;
  }

  save() {
    this.isLoading = false;
    this.isError = false;
    //detailform validation
    if (this.detailForm.controls["displayname"].value.toString().trim() == "") {
      this.showWarning("Label is mandatory");
      return;
    }
    if (this.detailForm.controls["viewname"].value.toString().trim() == "") {
      this.showWarning("View name is mandatory");
      return;
    }

    //criteria form validation
    if (
      this.criteriaForm.controls["filterbyowner"].value.toString().trim() ==
      "queue"
    ) {
      if (this.criteriaForm.controls["queueid"].value == "") {
        this.showWarning("You must choose a queue name");
        return;
      }
    }

    console.log("*****", this.criteriaForm.controls);

    //selected field list validation
    if (this.fieldsDone.length == 0) {
      this.showWarning("You must have atleast one field in the selected list");
      return;
    }

    var viewName = this.detailForm.controls["viewname"].value;
    //viewName = viewName.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    //viewName = viewName.replace(/ /g, "_");
    console.log(viewName);

    // this.metalayoutName =
    //   this.metaobjectName + "_" + "CustomView" + "_" + viewName;
    this.metalayoutName = viewName;
    var targetURL =
      "api/v1/" + this.metaobjectName.toLowerCase() + "/all/custom";

    var metalayoutAttributes = {
      relatedlistflag: false,
      notesandattachments: false,
      activity: false
    };

    var metaProfileLayoutAttributes = {
      queueid: this.criteriaForm.controls["queueid"].value.trim(),
      queuename: this.criteriaForm.controls["queuename"].value.trim(),
      filterbyowner: this.criteriaForm.controls["filterbyowner"].value.trim()
    };

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.metalayoutId = this.guid.getGUID("metalayout");
    }

    var hasRecordType = this.recordTypes.length > 0 ? true : false;

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        metalayout: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          relatedobjectid: "",
          hasrecordtype: hasRecordType,
          mode: this.mode,
          id: this.metalayoutId,
          displayname: this.detailForm.controls["displayname"].value.trim(),
          viewname: viewName,
          fieldhistory: false,
          approvalhistory: false,
          team: false,
          pathsetting: false,
          // viewname: this.detailForm.controls["displayname"].value.trim(),
          name: this.metalayoutName,
          action: "CustomView",
          layouttype: "CustomView",
          targeturl: targetURL,
          columncount: this.detailForm.controls["columncount"].value,
          tabkeyorder: this.detailForm.controls["tabkeyorder"].value.trim(),
          hascustomview: this.detailForm.controls["hascustomview"].value,
          clonable: this.detailForm.controls["clonable"].value,
          editable: this.detailForm.controls["editable"].value,
          deletable: this.detailForm.controls["deletable"].value,
          haskanbanview: this.detailForm.controls["haskanbanview"].value,
          searchtext: this.detailForm.controls["searchtext"].value.trim(),
          sortby: this.detailForm.controls["sortby"].value.trim(),
          sortorder: this.detailForm.controls["sortorder"].value.trim(),
          pagesize: this.appConfig.appDefaultPageSize,
          pagenumber: 1,
          userid: localStorage.getItem("crm_userid"),
          // publicaccess: this.detailForm.controls["publicaccess"].value,
          publicaccess: true,
          filterbyowner:
            this.criteriaForm.controls["filterbyowner"].value.trim(),
          queueid: this.criteriaForm.controls["queueid"].value.trim(),
          queuename: this.criteriaForm.controls["queuename"].value.trim(),
          active: true,
          attributes: metalayoutAttributes,
          sinceversionseq:
            this.detailForm.controls["sinceversionseq"].value != null
              ? this.detailForm.controls["sinceversionseq"].value
              : 0,
          deprecatedversionseq:
            this.detailForm.controls["deprecatedversionseq"].value != null
              ? this.detailForm.controls["deprecatedversionseq"].value
              : 0,
          category: this.detailForm.controls["category"].value,
          devicetype: this.detailForm.controls["devicetype"].value,
          metaprofilelayouts: [],
          metaprofilelayoutcriterias: [],
          metalayoutgroups: [],
          metaprofilelayoutwebs: [],
          metalayoutbuttons: [],
          layoutlabeltranslation: [] //will be served at server
        }
      }
    };

    //****** metaprofilelayout  *********/

    //metaprofilelayout
    if (this.mode.toLowerCase() == "new") {
      this.metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");
    } else if (this.mode.toLowerCase() == "edit") {
      if (this.metaProfileLayoutId == null || this.metaProfileLayoutId == "") {
        this.metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");
      }
    }

    var metaProfileLayout = {
      id: this.metaProfileLayoutId,
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      recordtypeid: "",
      profileid: null,
      description: "",
      actiontype: "CustomView",
      active: true,
      attributes: metaProfileLayoutAttributes
    };

    //push metaprofilelayout to request data (postoption)
    // postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    if (!postOption.data.metalayout.metaprofilelayouts) {
      postOption.data.metalayout.metaprofilelayouts = [];
    }

    if (postOption.data.metalayout.metaprofilelayouts.length === 0) {
      postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    }

    //****** metaprofilelayoutcriteria  *********/
    if (!this.metalayoutName.toLowerCase().trim().includes("recent")) {
      //create criteria details & push it to postOption
      var arrMetaProfileLayoutCriteria = this.createMetaProfileLayoutCriteria();
      //push metalayoutgroup to request data (postoption)
      postOption.data.metalayout.metaprofilelayoutcriterias =
        arrMetaProfileLayoutCriteria;
    }

    //****** metalayoutgroup  *********/

    //get metalayoutgroup details and assign it to postoption
    if (this.mode.toLowerCase() == "new") {
      this.metaLayoutGroupId = this.guid.getGUID("metalayoutgroup");
    } else if (this.mode.toLowerCase() == "edit") {
      if (this.metaLayoutGroupId == null || this.metaLayoutGroupId == "") {
        this.metaLayoutGroupId = this.guid.getGUID("metaprofilelayout");
      }
    }
    var groupSequence = 1;

    var metaLayoutGroup = {
      id: this.metaLayoutGroupId,
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      name: viewName,
      groupsequence: groupSequence,
      showondetailpage: true,
      showoneditpage: true,
      columncount: this.detailForm.controls["columncount"].value,
      active: true,
      imagesection: false,
      systemsection: false,
      metalayoutgroupfields: []
    };

    //****** metalayoutgroupfield *********/

    //create metalayoutgroupfield and assign it to metaLayoutGroup
    var arrMetaGroupField = this.createMetaLayoutGroupField(
      this.metaLayoutGroupId,
      groupSequence
    );
    //postOption.data.metalayout.metalayoutgroupfields = arrMetaGroupField;
    metaLayoutGroup.metalayoutgroupfields = arrMetaGroupField;

    //push metalayoutgroup to request data (postoption)
    postOption.data.metalayout.metalayoutgroups.push(metaLayoutGroup);

    //****** metaprofilelayout  *********/

    //metaprofilelayoutweb
    if (this.mode.toLowerCase() == "new") {
      this.metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayoutweb");
    } else if (this.mode.toLowerCase() == "edit") {
      if (
        this.metaProfileLayoutWebId == null ||
        this.metaProfileLayoutWebId == ""
      ) {
        this.metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayout");
      }
    }
    var metaProfileLayoutWeb = {
      id: this.metaProfileLayoutWebId,
      metaobjectid: this.metaobjectId,
      metaobjectname: this.metaobjectName,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      metalayoutname: this.metalayoutName,
      recordtypeid: null,
      recordtypename: "",
      profileid: null,
      profilename: "",
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      description: "",
      actiontype: "CustomView",
      active: true,
      layouttype: "CustomView",
      layoutjsontext: {},
      fieldjsontext: {},
      criteriajsontext: {}
    };

    //push metaprofilelayout to request data (postoption)
    postOption.data.metalayout.metaprofilelayoutwebs.push(metaProfileLayoutWeb);

    if (this.mode.toLocaleLowerCase() == "edit") {
      console.log(this.translatedLabels);

      if (this.translatedLabels) {
        var arrtranslatedLayouts = [];
        for (let translatedlayoutlabel of this.translatedLabels) {
          var layoutlabelTranslation = {
            id: this.guid.getGUID("metalayoutlabeltranslation"),
            organizationid: localStorage.getItem("crm_orgid"),
            metalayoutid: this.metalayoutId,
            languagecode: translatedlayoutlabel.languageCode,
            translatedlabel: translatedlayoutlabel.translatedName,
            active: true
          };

          //push it to array
          arrtranslatedLayouts.push(layoutlabelTranslation);
        }
        postOption.data.metalayout.layoutlabeltranslation =
          arrtranslatedLayouts;
      }
    }
    console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertMetalayout(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("Error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
